import React, { useEffect, useState } from 'react';
import FieldDropdown from '../components/FieldDropdown';
import BlueButton from '../components/BlueButton';
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv';
import { generateMongoDBId } from '../whitaijiFrontendLibrary/lib/utils';
import TextField from '../whitaijiFrontendLibrary/components/TextField';
import RichTextEditor from '../whitaijiFrontendLibrary/textEditors/RichTextEditor';
import { keyId } from '../whitaijiFrontendLibrary/lib/utils';
import AddButton from '../whitaijiFrontendLibrary/components/AddButton';
import { MdDelete } from "react-icons/md";
import { RxDragHandleHorizontal } from "react-icons/rx";
import { IoNavigateCircleOutline } from "react-icons/io5";
import { TbReportAnalytics } from "react-icons/tb";
import { FiEdit } from "react-icons/fi";
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext'
import { useStateContext } from '../context/StateContext';
import T from '../components/Translation';
import { useMutation, useQuery } from "@tanstack/react-query";
import queryClient from '../utils/queryClient';
import { _CREATE, _UPDATE } from '../utils/patches';
import { successAlert, errorAlert } from '../utils/utils';
import TrueFalseToggle from '../whitaijiFrontendLibrary/components/TrueFalseToggle';

const BuildSurvey = () => {


  const {user} = useAuthContext(AuthContext)
  const typeOptions = [
    { value: "radio", label: "Single Option", _id: 1 },
    { value: "multiple", label: "Multiple Options",  _id: 2 },
    { value: "shortText", label: "Short Text",  _id: 3 },
    { value: "longText", label: "Long Text",  _id: 4 },
  ];
  
/*   const dummyQuestions = [
    {surveyId: "ndewkjwenjkd", _id: "wlkdmwlkemd", title: "test Question A", type: "radio", description: "test description1", answerOptions:[{answerId: "woiwechku", answerText: "test answer 1"}, {answerId: "kwllwlwl", answerText: "test answer 2"}]},
    {surveyId: "ndewkjwenjkd", _id: "powkweicj", title: "test Question 2", type: "multiple", description: "test description2", answerOptions:[{answerId: "kwjkwejdcn", answerText: "test multiple answer 1"}, {answerId: "cojiewoidcnh", answerText: "test multiple answer 2"}]},
    {surveyId: "ndewkjwenjkd", _id: "lwlkwjecdnòqwj", title: "test Question 3", type: "shortText", description: "test description3"},
    {surveyId: "ndewkjwenjkd", _id: "wewqwkleiie", title: "test Question 4", type: "longText", description: "test description4"},
  ] */

  const [questions, setQuestions] = useState([]);
  const [title, setTitle] = useState('');

  const [toggleAddQuestion, setToggleAddQuestion] = useState(false);
  const {newSurvey, setNewSurvey, apiUrl, hideTestButtons} = useStateContext()
  const surveyId = newSurvey?._id ? newSurvey?._id : generateMongoDBId();

  useEffect(() => {
    if(newSurvey){
      setTitle(newSurvey?.title)
      setQuestions(newSurvey?.questions)  
    }
  },[newSurvey])
  
const updateTitle = (e) => {
  //setTitle(e.target.value)
  const newSurveyDoc = {
    title: e.target.value,
    _id: newSurvey?._id ? newSurvey?._id : surveyId,
    questions: questions,
    user_id : user._id
  };
  setNewSurvey(newSurveyDoc)
}

  const addQuestion = (dataBack) => {
    if (!dataBack || !dataBack._id) {
      process.env.NODE_ENV === "development" && console.error('Invalid question data');
      return;
    }
  
    const questionExists = questions.find((x) => x._id === dataBack._id);
    if (!questionExists) {
      //setQuestions([...questions, dataBack]);
      setNewSurvey({...newSurvey, questions: [...questions, dataBack]})
    } else {
      const updateQuestions = questions?.map((x) => {
        if (x._id === dataBack._id) {
          return dataBack;
        }
        return x;
      });
      //setQuestions(updateQuestions);
      setNewSurvey({...newSurvey, questions: updateQuestions})
    }
  };

  const [error, setError] = useState(null);

  const onError = (e) => {
    setError(e.error);
    errorAlert(e.error || 'Failed to save survey');
  }

  const onSuccess = (json, surveeyExists) => {
    if (json.error) {
      setError(json.error);
      errorAlert(json.error);
      return;
    }
    setError(null);
    const message = surveeyExists ? 'Survey edited successfully!' : 'Survey saved successfully!';
    successAlert(message);
  }

  // Fetch user's surveys
  const { data: userSurveys } = useQuery({
    queryKey: ['surveysData'],
    queryFn: async () => {
      try {
        const response = await fetch(`${apiUrl}/surveys`, {
          headers: {
            'Authorization': `Bearer ${user.token}`
          }
        });
        const data = await response.json();
        process.env.NODE_ENV === "development" && console.log("surveys loaded", data)
        return data;
      } catch (error) {
        process.env.NODE_ENV === "development" && console.error('Error fetching surveys:', error);
        return [];
      }
    },
    enabled: !!user // Only fetch if user is logged in
  });

  const { mutate: saveSurvey, isLoading } = useMutation({
    mutationFn: async(survey) => {
      try {
        if (newSurvey?._id) {
          // Check if survey exists in user's surveys
          const surveyExists = userSurveys?.some(s => s._id === newSurvey._id);
          
          if (surveyExists) {
            // Update existing survey
            const response = await _UPDATE({
              doc: survey, 
              user, 
              route: `${apiUrl}/surveys/${newSurvey._id}`, 
              onError
            });
            onSuccess(response, surveyExists);
            return response;
          } else {
            // Create new survey if it doesn't exist
            return await _CREATE({
              doc: { ...survey, _id: undefined }, // Remove _id for new creation
              user, 
              route: `${apiUrl}/surveys`, 
              onError, 
              onSuccess
            });
          }
        } else {
          // Create new survey
          return await _CREATE({
            doc: survey, 
            user, 
            route: `${apiUrl}/surveys`, 
            onError, 
            onSuccess
          });
        }
      } catch (error) {
        onError(error);
        throw error;
      }
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['surveysData'] }),
    mutationKey: ['surveysData'],
  });

  const handleAddNewSurvey = () => {
    setNewSurvey({
      title: '',
      questions: [],
      user_id: user._id,
      _id: generateMongoDBId()
    })
  }

  const handleClose = () => {
    setNewSurvey(null)
  }

  const handleSave = () => {
    if (!user) {
      setError('You must be logged in');
      return;
    }

    if (!title) {
      setError('Survey title is required');
      return;
    }

    if (!questions || questions.length === 0) {
      setError('Survey must contain at least one question');
      return;
    }

    // Validate questions format before saving
    // Format survey data to match the model schema
    const formattedSurvey = {
      title: title,
      description: {
        blocks: [],
        entityMap: {}
      },
      user_id: user._id,
      questions: questions?.map(q => ({
        _id: q._id,
        required: q.required,
        title: q.title,
        type: q.type,
        description: q.description || {
          blocks: [],
          entityMap: {}
        },
        answerOptions: q.answerOptions || []
      }))
    };
    
    saveSurvey(formattedSurvey);
  }
  const toggleAddQuestionFn = () => {
    setToggleAddQuestion(!toggleAddQuestion)
  }
  return (
    <div style={{padding:"20px"}}>
      <VisDiv rules={[true]}>
      <div style={{display: 'flex', gap: '10px', marginBottom: '20px'}}>
            <BlueButton fn={handleAddNewSurvey} text='New Survey' color="blue" disabled={isLoading} />
            {error && <div style={{color: 'red'}}>{error}</div>}
          </div>
        <h2>Surveys</h2>
        {userSurveys?.map((item) => (
          <div key={item._id}>
            <SurveyPin survey={item} setNewSurvey={setNewSurvey} />
          </div>
        ))}
      </VisDiv>
      <VisDiv rules={[newSurvey]}>
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <div style={{display: 'flex', gap: '10px', marginBottom: '20px'}}>
            <BlueButton fn={handleSave} text='Save Survey' color="green" disabled={isLoading} />
            {error && <div style={{color: 'red'}}>{error}</div>}
          </div>
          <div style={{display: 'flex', gap: '10px', marginBottom: '20px'}}>
            <BlueButton fn={handleClose} text='Close Survey' color="blue" disabled={isLoading} />
            {error && <div style={{color: 'red'}}>{error}</div>}
          </div>
        </div>
        <TextField label="Survey Title" value={title} onBlur={updateTitle} onChange={(e) => setTitle(e.target.value)} />
        {questions?.map((item) => (
          <VisDiv rules={[true]} key={item._id}>
            <Question data={{ question: item, typeOptions, surveyId }} editQuestion={addQuestion} />
          </VisDiv>
        ))}
        <VisDiv rules={[!toggleAddQuestion]}>
          <AddButton onClick={toggleAddQuestionFn} label={<T str={"addQuestion"}/>} />
        </VisDiv>
        <VisDiv rules={[toggleAddQuestion]}>
          <AddEditQuestion saveFn={addQuestion} data={{ typeOptions, surveyId, hideTestButtons, setToggleAddQuestion }} />
        </VisDiv>
      </VisDiv>
    </div>
  );
};

export default BuildSurvey;

export const SurveyPin = ({survey, setNewSurvey}) => {
  const surveyUrl = `${window.location.origin}/survey?_id=${survey._id}`;
  const surveyReportUrl = `${window.location.origin}/survey-report?_id=${survey._id}`;
  
  return (
    <VisDiv style={{padding:"20px", display:"flex", flexDirection:"row"}} rules={[true]}>
      <h3>{survey.title}</h3>
      <div style={{display: 'flex', justifyContent: 'left', alignItems: 'center', marginLeft: '30px'}}>
        <FiEdit 
          style={{cursor: 'pointer', marginRight: '10px'}} 
          size={20} 
          onClick={() => setNewSurvey(survey)}
        />
        <IoNavigateCircleOutline
          style={{cursor: 'pointer', marginRight: '10px'}} 
          size={27} 
          onClick={() =>  window.open(surveyUrl, '_blank')}
        />
        <TbReportAnalytics
            style={{cursor: 'pointer', marginRight: '10px'}} 
            size={27} 
            onClick={() =>  window.open(surveyReportUrl, '_blank')}
        />
{/*       <BlueButton 
        fn={() => window.open(surveyUrl, '_blank')}
        text="Open Survey" 
        color="green"
      /> */}
      </div>

    </VisDiv>
  )
}

export const Question = ({ data = {}, editQuestion=() => {} }) => {
  const [toggleAddQuestion, setToggleAddQuestion] = useState(false);
  const toggleAddQuestionFn = () => {
    setToggleAddQuestion(!toggleAddQuestion)
  }
  const {question, typeOptions, surveyId} = data;
  return (
    <VisDiv>
      <h2>{question?.title}{question?.required && "*"}</h2>
      <h4 style={{color:"red"}}>{question?.required && "Required"}</h4>
      <RichTextEditor noFocus={true} existingDoc={question?.description} readOnly={true} updateInitialData={true}/> 
      <VisDiv className="nargin-bottom" rules={[question?.answerOptions?.length > 0]}>
        {question?.answerOptions?.map((item, index) => {
          return (
            <div key={item?.answerId} className='flex-row'>
              <p>Option {index + 1}:</p>
              <div className="margin-left">
                {item?.answerText}
              </div>
            
            </div>
            
          )
        })}

      </VisDiv>
      <VisDiv rules={[!toggleAddQuestion]}>
        <BlueButton fn={toggleAddQuestionFn} hide={false} text={"Edit Question"} />
      </VisDiv>
      <VisDiv rules={[toggleAddQuestion]}>
        <AddEditQuestion
          saveFn={editQuestion}
          data={{ edit: true, existingDoc: question, typeOptions, surveyId, setToggleAddQuestion }}
        />
      </VisDiv>

    </VisDiv>
  );
};

export const AddEditQuestion = ({ data = {}, saveFn = () => {} }) => {
  const { typeOptions, surveyId, existingDoc, edit, setToggleAddQuestion, hideTestButtons } = data;

  const [type, setType] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState(null);
  const [richTextExistingDoc, setRichTextExistingDoc] = useState();
  const [answerOptions, setAnswerOptions] = useState([]);
  const [required, setRequired] = useState(false);

  const _id = existingDoc?._id ? existingDoc?._id : generateMongoDBId();

  useEffect(() => {
    if (existingDoc) {
      setType(existingDoc?.type);
      setRequired(existingDoc?.required);
      setTitle(existingDoc?.title);
      setDescription(existingDoc?.description);
      setRichTextExistingDoc(existingDoc?.description);
      setAnswerOptions(existingDoc?.answerOptions);
    }
  }, [existingDoc]);

  const questionDoc = {
    _id,
    type,
    required,
    surveyId,
    title,
    description,
    answerOptions,
  };

  const editorDoc = (data) => {
    const newValue = { ...data, blocks: data?.blocks?.map((x) => ({ ...x, _key: keyId() })) };
    setDescription(newValue);
  };

  const onBlurFn = () => {};

  const addEmptyQuestion = () => {
    const emptyAnswerOption = { answerId: generateMongoDBId(), answerText: "" };
    setAnswerOptions([...answerOptions, emptyAnswerOption]);
  };
  const saveQuestion = () => {
    saveFn(questionDoc);
    process.env.NODE_ENV === "development" && console.log("questionDoc", questionDoc)
    //setType(null);
    setTitle("");
    setRequired(false);
    setDescription(null);
    setRichTextExistingDoc(null);
    setAnswerOptions([]);
    if(edit){
      setToggleAddQuestion(false);
    }

  };
  const cancelAddQuestion = () => {
    setToggleAddQuestion(false);
    setType(null);
    setTitle("");
    setRequired(false);
    setDescription(null);
    setRichTextExistingDoc(null);
    setAnswerOptions([]);
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedOptions = Array.from(answerOptions);
    const [removed] = reorderedOptions.splice(result.source.index, 1);
    reorderedOptions.splice(result.destination.index, 0, removed);
    setAnswerOptions(reorderedOptions);
  };
  const containerString = !edit ? "Add Question" : "Edit Question";

  return (
    <div className="add-question-container">
      <h3>{containerString}</h3>
      <BlueButton fn={() => process.env.NODE_ENV === "development" && console.log("questionDoc", existingDoc, typeOptions, typeOptions?.find((x) => x.value === existingDoc?.type))} hide={hideTestButtons} text={"Test Add Question"} />
      <h4>Question Type</h4>
      <FieldDropdown
        options={typeOptions}
        onChange={(e) => setType(e?.value)}
        placeholder="Select a question type"
        initialValue={typeOptions?.find((x) => x.value === existingDoc?.type)}
        isMulti={false}
      />
      <VisDiv rules={[type]}>
        <TextField
          label={"Question Title"}
          onChange={(e) => setTitle(e.target.value)}
          value={title}
          onBlur={onBlurFn}
        />
        <h4>Question Description</h4>
        <RichTextEditor
          onChange={(e) => setDescription(e.target.value)}
          onBlur={onBlurFn}
          noFocus={true}
          editorDoc={editorDoc}
          updateInitialData={true}
          existingDoc={richTextExistingDoc}
        />
        <TrueFalseToggle 
          label={"Required"} 
          value={required} 
          onClick={() => setRequired(!required)} 
        />
        <VisDiv ruleType="OR" rules={[type === "radio", type === "multiple"]}>
          <div>
            <h2 className='flex-center-column margin-bottom'>Answer Options</h2>
          </div>
  
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="answerOptions">
              {(provided) => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  {answerOptions?.map((item, index) => (
                    <Draggable key={item.answerId} draggableId={item.answerId} index={index}>
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <AnswerOption
                            data={{
                              answerOption: item,
                              index,
                              answerOptions,
                              setAnswerOptions,
                            }}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <AddButton onClick={addEmptyQuestion} label={"Add Answer Option"} />
        </VisDiv>
        <VisDiv className="flex-center-row">
          <BlueButton fn={saveQuestion} color={"green"} hide={false} text={"Save"} />
        </VisDiv>
      </VisDiv>
      <VisDiv className="flex-center-row">
       <BlueButton fn={cancelAddQuestion} color={"grey"} hide={false} text={"Chiudi"} />
      </VisDiv>
    </div>
  );
};

export const AnswerOption = ({ data }) => {
  const { answerOption, index, answerOptions, setAnswerOptions } = data;

  const deleteAnswerOption = () => {
    const newAnswerOptions = answerOptions?.filter((x) => x?.answerId !== answerOption?.answerId);
    setAnswerOptions(newAnswerOptions);
  };

  return (
    <div key={answerOption?.answerId}>
      <div className="flex-row space-between-row ">
        <h4>Option {index + 1}</h4>
        <RxDragHandleHorizontal size={20} color="grey" />
        <div className="delete-trash-can" onClick={deleteAnswerOption}>
          <MdDelete size={20} color="red" />
        </div>
      </div>
      <TextField
        value={answerOption?.answerText}
        onChange={(e) => {
          const newAnswerOptions = answerOptions?.map((x) => {
            if (x?.answerId === answerOption?.answerId) {
              return { ...x, answerText: e.target.value };
            }
            return x;
          });
          setAnswerOptions(newAnswerOptions);
        }}
      />
    </div>
  );
};
